<template>
  <div class="home games-page-list">
    <ViewBar></ViewBar>
    <div class="main">
      <GameList></GameList>
      <div class="game-table">
      </div>
    </div>
  </div>
</template>

<script>
import staticParam from '@/../json/static.json';
import ViewBar from '@/components/PmPages/ViewBar.vue';
import GameList from '@/components/PmPages/GamesList.vue';

export default {
  name: 'Home',
  components: {
    ViewBar,
    GameList,
  },
  data() {
    return {
      staticParam,
      prevRoute: null,
      prevId: null,
      filtered: [],
    };
  },

  beforeRouteEnter(to, from, next) {
    next((vm) => {
      const regex = /^\/stats\/(\d+)/gm;
      if (from.path.match(regex)) {
        // eslint-disable-next-line no-param-reassign
        vm.prevId = from.params.gameId;
      }
    });
  },
};
</script>

<style lang="scss">
.main {
  justify-content: center;
}

.home {
  .main {
    padding: 0 20px;
    @media screen and (max-width: 700px) {
      padding: 0 10px;
    }
    .el-cascader {
      .el-input {
        margin-left: 0;
      }
      .el-cascader__tags {
        flex-wrap: initial;
        overflow: auto;
        span {
          white-space: nowrap;
        }
      }
      input {
        font-size: 14px;
      }
    }

    span.el-switch__label:not(.is-active) {
      color: $darker-grey;
    }
    .el-switch {
      flex-direction: row-reverse;
      .el-switch__label--right {
        margin-right: 10px;
      }
    }
  }

  .el-date-editor {
    max-width: 250px;
    @media screen and (max-width: 1200px) {
      max-width: 220px;
    }
  }
  .game-table {
    box-shadow: 0 3px 10px 0 rgba(198, 219, 240, 0.25);
    @media screen and (max-width: 900px) {
      width: 100%;
      position: fixed;
    }
  }
  .mobile-date {
    display: flex;
    overflow: auto;
    .el-input {
      width: 140px;
    }
  }
}
</style>
